<template lang="pug">
.page-container
  .header
    swiper.slider-container(
      :options="swiperOption"
      @ready="ins => handleReady(ins)"
      @slide-change="handleSlideChange"
    )
      swiper-slide(
        class="right-slide-item"
        v-for="(item, index) in store.propertyList"
        :key="index"
      )
        .rights-item(@click="ev => handleClick(ev, index)")
          .top-mark.app-only(v-if="item.topMarkAppOnly")
            img.top-mark-bg(src="@/assets/member/app_only.png")
          img.rights-item-img(
            v-if="item.propStatus === 1"
            :src="item.propActiveIcon"
          )
          img.rights-item-img(
            v-if="item.propStatus === 0"
            src="@/assets/member/icon_suo@2x.png"
          )
          span.rights-item-text {{ item.propName }}
  .limit-range
    .limit-range-title 使用范围
    .limit-range-list
      .limit-item(v-for="item in activedProp.applyLevels || []")
        img.limit-item-img(:src="item.levelIcon")
        span.limit-item-text {{ item.levelName }}

  .desc
    .desc-title 权益说明
    .desc-content(v-html="activedProp.propDesc")

  .bottom-btn(
    v-if="activedProp.actionStatus"
    @click="handleSubmit"
  ) {{ btnText }}
  rights-modal(:data="rightsData" :visible.sync="visible")

</template>
<script>
import { Native } from '@hb/NBridge/lib/h5';
import { getProperty } from '@/api/rights';
import Toast from '@/components/toast';
import rightsModal from './components/rightsModal';
import {
  store,
  appTask,
  initUserBaseInfo,
  loadSwitchStatus,
  initBaseProperty,
  updateUserProperty,
} from './store';

// 行为枚举
const propEnums = {
  DOWNLOAD_APP: {
    redirect: true,
    text: () => '下载APP领取',
  },
  // 下载APP领取
  RECEIVED_DOWNLOAD_APP: {
    redirect: true,
    text: () => '下载APP查看更多',
  },
  // 已领取下载APP查看
  NOT_APP_UNRECEIVED: {
    redirect: false,
    text: (obj) => obj.giftCanReceiveBtnTitle,
  },
  // 非APP且未领取
  NOT_APP_RECEIVED: {
    redirect: true,
    text: () => '下载APP查看更多',
  },
  // 非APP且未领取
  UNKNOW: null,
};

const promise = {};
export default {
  components: {
    rightsModal,
  },
  data() {
    return {
      visible: false,
      store: store.state,
      swiperOption: {
        initialSlide: 0,
        slidesPerView: 4,
        spaceBetween: 0,
        centeredSlides: true,
      },
      activedPropIdx: -1,
      rightsData: {},
    };
  },
  computed: {
    /**
     * 抽卡权益：
     * 可领取：下载APP领取  - 跳链接
     * 已领取：已领取, 下载APP查看更多权益 - 跳链接
     * app专属：
     * 可领取：下载APP领取  - 跳链接
     * 已领取：已领取, 下载APP查看更多权益 - 跳链接
     * 非app专属、非抽卡权益：
     * 可领取：立即领取(配置的文案)- 调领取接口
     * 已领取：已领取, 下载APP查看更多权益 - 跳链接
     */
    calcPropMode() {
      if (this.activedProp.propType === 2 || this.activedProp.propChannel === 1) {
        if (this.activedProp.giftStatus === 0) {
          return propEnums.RECEIVED_DOWNLOAD_APP;
        }
        return propEnums.DOWNLOAD_APP;
      }
      if (this.activedProp.giftStatus === 0) {
        return propEnums.RECEIVED_DOWNLOAD_APP;
      }
      return propEnums.NOT_APP_UNRECEIVED;

      // return propEnums.UNKNOW;
    },
    btnText() {
      if (this.calcPropMode) {
        return this.calcPropMode.text(this.activedProp);
      }
      return '';
    },
    activedProp() {
      if (this.activedPropIdx === -1) {
        return {
          propType: undefined,
          propChannel: undefined,
          giftStatus: undefined,
          actionStatus: undefined,
          applyLevels: [],
        };
      }
      return this.store.propertyList[this.activedPropIdx] || {};
    },
  },
  created() {
    promise.swiper = new Promise((resolve) => {
      promise.resolve = resolve;
    });
  },
  async mounted() {
    Native.callNative({
      method: 'setNavigationBar',
      params: {
        title: '会员中心',
        backgroundColor: '#2d3139',
      },
    });
    await initUserBaseInfo();
    loadSwitchStatus();
    const { guid } = this.$route.query;
    initBaseProperty()
      .then(() => {
        if (guid) {
          const idx = this.store.propertyList
            .findIndex((p) => p.propGuid === guid);
          this.selectProp(idx);
        } else {
          this.selectProp(0);
        }
        updateUserProperty();
      });
  },
  methods: {
    async selectProp(idx, speed = 100) {
      const realIdx = idx > -1 ? idx : 0;
      this.activedPropIdx = realIdx;

      const swiperIns = await promise.swiper;
      if (swiperIns) {
        swiperIns.slideTo(realIdx, speed);
      }
    },
    handleReady(instance) {
      promise.resolve(instance);
    },
    handleClick(ev, index) {
      this.selectProp(index);
    },
    async handleSlideChange() {
      const swiperIns = await promise.swiper;
      this.selectProp(swiperIns.activeIndex);
    },
    async handleSubmit() {
      if (this.calcPropMode.redirect) {
        // 跳转下载APP
        Native.callNative({
          method: 'goOperationUrl',
          params: appTask.xcxActionUrl,
        });
        return;
      }

      try {
        const { data } = await getProperty({
          propGuid: this.activedProp.propGuid,
          ...store.baseParams,
        });
        if (data && data.coupon) {
          this.rightsData = data.coupon;
          this.visible = true;
        }
        updateUserProperty();
      } catch (ex) {
        Toast.showError(ex);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-container {
  position: relative;
  min-height: 100%;
  background-color: #f8f8f8;

  .header {
    width: 100%;
    background-color: #2d313a;
    padding: 0.1rem 0 0;
    margin-bottom: 0.2rem;

    .slider-container {
      width: 100%;
      height: 125px;

      &::after {
        content: '';
        width: 0;
        height: 0;
        border: 8px solid;
        border-color: transparent transparent #f8f8f8;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        top: 100%;
        margin-top: -16px;
        z-index: 1;
      }

      .right-slide-item {
        display: flex;
        align-items: center;
        justify-content: center;

        .rights-item {
          position: relative;
          transition: all ease-in-out 0.2s;
          display: flex;
          flex-direction: column;
          align-items: center;
          opacity: 0.71;

          .rights-item-img {
            width: 0.52rem;
            height: 0.52rem;
            margin-bottom: 0.06rem;
          }

          .rights-item-text {
            display: block;
            color: #fff;
            font-size: 12px;
            line-height: 17px;
            white-space: nowrap;
            word-break: keep-all;
          }
        }

        &.swiper-slide-active .rights-item {
          opacity: 1;
          transform: scale(1.333);
        }
      }
    }
  }

  .limit-range {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);
    border-radius: 4px;
    padding: 0.2rem 0 0;
    width: 3.45rem;
    margin: 0 auto 0.2rem;

    .limit-range-title {
      color: #333;
      font-size: 14px;
      font-weight: 400;
      padding-left: 0.2rem;
      margin-bottom: 0.08rem;
    }

    .limit-range-list {
      display: flex;
      flex-wrap: wrap;

      .limit-item {
        width: 33.333%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 0.2rem;
        margin-top: 0.04rem;

        .limit-item-img {
          width: 0.4rem;
          height: 0.4rem;
          margin-bottom: 0.06rem;
        }

        .limit-item-text {
          display: block;
          color: #333;
          font-size: 13px;
          line-height: 18px;
        }
      }
    }
  }

  .desc {
    padding-bottom: 0.62rem;

    .desc-title {
      color: #666;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      padding-left: 0.15rem;
      margin-bottom: 0.12rem;
    }

    .desc-content {
      padding: 0 0.15rem;
      color: #999;
      font-size: 12px;
      font-weight: 300;
      line-height: 20px;
    }
  }

  .bottom-btn {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #0b82f1;
    font-size: 17px;
    line-height: 0.5rem;
    text-align: center;
    color: #fff;
  }

  .top-mark {
    position: absolute;
    z-index: 1;
    top: -0.05rem;
    left: 55%;
    width: 30px;
    height: 14px;
    text-align: center;

    &.app-only {
      width: 46px;
      height: 18px;
      top: -0.08rem;
    }

    .top-mark-bg {
      position: absolute;
      z-index: 1;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
